import { useQuery } from "@tanstack/react-query";
import { ITToolRequestService } from "../../../../../services/it-tools-request/itToolRequest.service";
import { useSelector } from "../../../../../store/store";

export const useDemandForSuppliesRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;
  const email = "thiennv@viags.vn";

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["demand-for-supplies-requests"],
    queryFn: () => ITToolRequestService.getITToolRequests(email),
  });

  const { data: data2 = [] } = useQuery<Array<any>>({
    queryKey: ["demand-for-supplies-requests2"],
    queryFn: () => ITToolRequestService.getITToolRequests(userEmail),
  });

  const demandForSuppliesMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const mappedDemandForSuppliesRequests = data
    .map((record) => {
      // const status = getStatusBaseOnApprover(record, email);
      // const step = getStepBaseOnApprover(record, email);
      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        // eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedDemandForSuppliesRequests2 = data2
    .map((record) => {
      // const status = getStatusBaseOnApprover(record, email);
      // const step = getStepBaseOnApprover(record, email);
      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        // eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedDemandForSuppliesMyRequests = mappedDemandForSuppliesRequests
    .filter((record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase())
    .sort((a, b) => b.id - a.id);

  const guideLink =
    "https://drive.google.com/file/d/1GzF2T2n0LBWtL5vVimv-rf6pL7N0D4gA/view";

  return {
    ...restResponse,
    demandForSuppliesRequests: data,
    demandForSuppliesMyRequests,
    mappedDemandForSuppliesRequests,
    mappedDemandForSuppliesMyRequests,
    mappedDemandForSuppliesRequests2,
    guideLink,
  };
};
